import { sessionManager } from '../config/sessionManager';

/** Shot chart stays limited to Western Reserve Academy while it is in beta. */
const SHOT_CHART_CLIENT_ID = '690a32da54cd0906d4289c63';

export function isShotChartClient(clientId?: string | null): boolean {
  const id = clientId === undefined ? sessionManager.getClientId() : clientId;
  return id === SHOT_CHART_CLIENT_ID;
}
